import {
  AfterViewInit,
  Component,
  ElementRef,
  ViewChild,
  OnDestroy,
  OnInit,
} from '@angular/core';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { CSS2DRenderer } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
import {
  SceneService,
  ModelLoaderService,
  DetailsPopupService,
  InputFetchService,
  MonotainerService,
  LoaderService,
  TagUntagService,
} from '../../../services/index';
import { MonotainerDetails } from '../inputGroup';
import { Object3D } from 'three';
import { CSS3DRenderer } from 'three/examples/jsm/renderers/CSS3DRenderer.js';
@Component({
  selector: 'app-my-scene',
  templateUrl: './my-scene.component.html',
  styleUrls: ['./my-scene.component.css'],
})
export class MySceneComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild('canvas') private canvasRef!: ElementRef<HTMLDivElement>;
  loading$ = this._loaderService.loading$; 

  constructor(
    private _sceneService: SceneService,
    private _modelLoaderService: ModelLoaderService,
    private _detailsPopupService: DetailsPopupService,
    private _inputFetchService: InputFetchService,
    private _monotainerService: MonotainerService,
    private _loaderService: LoaderService,
    private _tagUntagService: TagUntagService
  ) {}

  //? Scene properties
  private _camera!: THREE.PerspectiveCamera;
  private _controls!: OrbitControls;
  private _loader!: THREE.TextureLoader;
  private _renderer!: THREE.WebGLRenderer;
  private _mouse!: THREE.Vector2;
  private _raycaster!: THREE.Raycaster;
  private _labelRenderer!: CSS2DRenderer;
  private _css3dRenderer!: CSS3DRenderer;
  private _hemiSphereLight: THREE.HemisphereLight;
  private _directionalLight: THREE.DirectionalLight;
  private _ambientLight: THREE.AmbientLight;
  private _scene: THREE.Scene;
  private _models: THREE.Object3D[] = [];
  private _lights: THREE.Light[] = [];
  private _flag: boolean = true;
  private _id: number;
  private _selected: Object3D[] = [];
  private _laneNames: string[]=[];
  ngOnInit(): void {
    this._scene = this._sceneService.getScene();
  }

  async ngAfterViewInit() {
    //Sets up CSS2DRenderer
    this._renderer = this._createRenderer(this.canvasRef.nativeElement);
    this._labelRenderer = new CSS2DRenderer();
    this._labelRenderer.domElement.style.position = 'absolute';
    this._labelRenderer.domElement.style.top = '0';
    this._labelRenderer.domElement.style.left='0'
    //sets up CSS3DRenderer
    this._css3dRenderer = new CSS3DRenderer();
    this._css3dRenderer.domElement.style.position = 'absolute';
    this._css3dRenderer.domElement.style.top = '0';
    this._css3dRenderer.domElement.style.margin='0'
    this._css3dRenderer.domElement.style.left='0'
    this._createScene();
    this._laneNames = this._modelLoaderService.getLaneName();
    await this._createMonotainer();
    this._createControls();
    this._startRenderingLoop();
    this._setRenderer();
    this._models = this._modelLoaderService.getModels();
    window.addEventListener( 'resize', this._onWindowResize );
    this._css3dRenderer.domElement.addEventListener(
      'click',
      (event: { clientX: number; clientY: number }) => {
        getMeshIntersection(event.clientX, event.clientY);
      }
    );
    this._css3dRenderer.domElement.addEventListener(
      'mousemove',
      (event: { clientX: number; clientY: number }) => {
        mouseChange(event.clientX, event.clientY);
      }
    );
    this._css3dRenderer.domElement.addEventListener('mouseup', (event: any) => {
      this._detailsPopupService.removeAlert();
    });

    //gets the mouse pointer location and check if it intersects with a 3d object
    const getMeshIntersection = (clientX: number, clientY: number) => {
      this._mouse = new THREE.Vector2();
      this._raycaster = new THREE.Raycaster(this._camera.position);
      const rect = this._renderer.domElement.getBoundingClientRect();
      this._mouse.x =
        ((clientX - rect.left) / (rect.right - rect.left)) * 2 - 1;
      this._mouse.y =
        -((clientY - rect.top) / (rect.bottom - rect.top)) * 2 + 1;
      this._raycaster.setFromCamera(this._mouse, this._camera);
      const intersections = this._raycaster.intersectObjects(
        this._scene.children,true);
      if (
        intersections.length > 0 &&
        intersections[0].object.parent?.name !== 'factoryGround' &&
        intersections[0].object.parent.type == 'Group' &&
        !this._laneNames.includes(intersections[0].object.parent.name)&&
        intersections[0].object.parent.name!=='forkliftSort' &&
        intersections[0].object.parent.name!=="Scene"
      ) {
        this._detailsPopupService.appendAlertMonotainer(
          intersections[0].object.parent.parent
        );
      }
      if (intersections.length > 0 &&
        this._laneNames.includes(intersections[0].object.parent.name) &&
        intersections[0].object.parent?.type == 'Group'
      ) {
        this._detailsPopupService.appendAlertLane(
          intersections[0].object.parent
        );
      }
      return null;
    };

    //changes pointer icon when hovers over a 3d object and increase its size
    const mouseChange = (clientX: number, clientY: number) => {
      this._mouse = new THREE.Vector2();
      this._raycaster = new THREE.Raycaster(this._camera.position);
      const rect = this._renderer.domElement.getBoundingClientRect();
      this._mouse.x =
        ((clientX - rect.left) / (rect.right - rect.left)) * 2 - 1;
      this._mouse.y =
        -((clientY - rect.top) / (rect.bottom - rect.top)) * 2 + 1;
      this._raycaster.setFromCamera(this._mouse, this._camera);
      const intersections = this._raycaster.intersectObjects(
        this._scene.children,
        true
      );
      if (intersections[0] !== undefined) {  
        if (
          this._laneNames.includes(intersections[0].object.parent.name) ||
          (intersections[0].object.parent.name.startsWith('Cube') &&
            intersections[0].object.parent?.type == 'Group' &&
            intersections[0].object.parent?.name !== 'factoryGround')
        ) {
          document.documentElement.style.cursor = 'pointer';

          if (
            intersections[0].object.parent.name.startsWith('Cube') &&
            intersections[0].object.parent?.type == 'Group' &&
            intersections[0].object.parent?.name !== 'factoryGround'
          ) {
            intersections[0].object.parent.parent!.scale.set(0.1, 0.1, 0.1);
            this._selected.push(intersections[0].object.parent.parent);
          }
        } else {
          this._selected.forEach((element) => {
            element.scale.set(0.09, 0.09, 0.09);
          });
          this._selected = [];
          document.documentElement.style.cursor = 'default';
        }
      }
      return null;
    };
  }

  ngOnDestroy() {
    this._renderer.dispose();
    this._scene.traverse((obj) => {
      if (obj instanceof THREE.Mesh) {
        obj.geometry.dispose();
        obj.material.dispose();
      }
    });
    this._models.forEach((model) => {
      this._scene.remove(model);
    });
    this._lights.forEach((light) => {
      this._scene.remove(light);
      light.dispose();
    });
    this._renderer.domElement.remove();
    this._labelRenderer.domElement.remove();
    cancelAnimationFrame(this._id);
    this._scene = null;
    this._models = [];
    this._lights = [];
    this._modelLoaderService.setModelLoadFlag(false);
    this._tagUntagService.clearInlaneMonotainers();
    this._tagUntagService.setLaneStackPosition();
  }

  /**
   * Create controls to view model in 3d plane
   */
  private _createControls = () => {
    this._controls = new OrbitControls(
      this._camera,
      this._css3dRenderer.domElement
    );
    this._controls.minDistance = 9;
    this._controls.maxDistance = 20;
    this._controls.enablePan = false;
    this._controls.maxPolarAngle = Math.PI / 2.5;
    this._controls.maxAzimuthAngle = Math.PI /2.5;
    this._controls.minAzimuthAngle = -Math.PI /2;
    this._controls.update();
  };

  /**
   * Creates renderer
   * @param canvas
   * @returns renderer
   */
  private _createRenderer(canvas: HTMLElement): THREE.WebGLRenderer {
    this._renderer = new THREE.WebGLRenderer();//{ canvas, antialias: true }
    canvas.appendChild(this._renderer.domElement)
    this._renderer.setPixelRatio(Math.max(window.devicePixelRatio, 2));
    this._renderer.setSize(this.canvasRef.nativeElement.clientWidth,this.canvasRef.nativeElement.clientHeight)
    this._renderer.shadowMap.enabled = true;
    this._renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    this._sceneService.setRenderer(this._renderer);
    return this._renderer;
  }

  /**
   * Creates scene where models are loaded
   * here the lighting needed and the camera along with the models are rendered
   */
  private async _createScene() {
    this._scene.background = new THREE.Color(0x000000);
    const factoryModel_position = new THREE.Vector3(-4, 2.6, -1.5);
    const factoryModel_scale = new THREE.Vector3(0.06, 0.06, 0.06);
    const factoryMOdel_rotation = 0;
    await this._modelLoaderService.setFactoryModel(
      factoryModel_position,
      factoryModel_scale,
      factoryMOdel_rotation
    );
    const forkLift1_position = new THREE.Vector3(-8, 2.6, -3);
    const forkLift1_scale = new THREE.Vector3(0.05, 0.05, 0.05);
    const forkLift1_rotation = 2 * Math.PI;
    await this._modelLoaderService.setModelForkLift(
      forkLift1_position,
      forkLift1_scale,
      forkLift1_rotation
    );
    this._tagUntagService.setStartPosition(forkLift1_position);
    //sets up models
    this._modelLoaderService.setCCTV();
    this._modelLoaderService.setTruck();
    this._modelLoaderService.setLanes();
    this._camera = this._sceneService.createCamera(
      this.canvasRef.nativeElement
    );
    this._camera.position.set(0, 7, 10);
    //lights on scene
    this._hemiSphereLight = new THREE.HemisphereLight(0x20acb9, 0xacb920, 2);
    this._scene.add(this._hemiSphereLight);
    this._lights.push(this._hemiSphereLight);
    this._directionalLight = new THREE.DirectionalLight(0xffffff, 3);
    this._directionalLight.position.set(-11, 6, 5);
    this._directionalLight.target.position.set(-5, 0, -1);
    this._directionalLight.castShadow = false;
    this._scene.add(this._directionalLight);
    this._lights.push(this._directionalLight);
    this._ambientLight = new THREE.AmbientLight(0xffffff, 2.5);
    this._scene.add(this._ambientLight);
    this._lights.push(this._ambientLight);
    // loads the black ground
    this._loader = new THREE.TextureLoader();
    const texture = this._loader.load('assets/models//ground.jpg');
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.magFilter = THREE.NearestFilter;
    texture.repeat.set(40, 40);
    const planeGeo = new THREE.PlaneGeometry(40, 30);
    const planeMat = new THREE.MeshPhongMaterial({
      map: texture,
      side: THREE.DoubleSide,
    });
    const mesh = new THREE.Mesh(planeGeo, planeMat);
    mesh.receiveShadow = true;
    mesh.rotation.x = Math.PI * -0.5;
    mesh.name = 'ground';
    mesh.position.set(-2, 2.5, -2);
    mesh.receiveShadow = false;
    this._scene.add(mesh);
  }

  /**
   * Starts rendering the scene every frame
   */
  private _startRenderingLoop() {
    const clock = new THREE.Clock();
    let mixer = this._modelLoaderService.getMixer();
    let component: MySceneComponent = this;
    const animate = () => {
      var delta = clock.getDelta();
      if (mixer) mixer.update(delta);
      component._renderer.render(component._scene, component._camera);
      component._labelRenderer.render(component._scene, component._camera);
      component._css3dRenderer.render(component._scene, component._camera);
      component._id = requestAnimationFrame(animate);
    };
    animate();
  }

  /**
   * Creates monotainer and stacks them in scene
   * @returns monotainer
   */
  private _createMonotainer(): Promise<void> {
    this._loaderService.show();
    return new Promise<void>(async (resolve) => {
      try {
        const MonotainerList: MonotainerDetails[] =
          await this._inputFetchService.getAvailableMonotianers();
        await this._monotainerService.stackMonotainer(MonotainerList);
        this._monotainerService.resetValue();
        this._modelLoaderService.setModelLoadFlag(true);
        this._tagUntagService.modelLoaded.emit(true);
        resolve();
      } catch (error) {
        console.error('Error in createMonotainer:', error);
      }
    });
  }

  /**
   * Sets css2d and css3d renderer to scene
   */
  private _setRenderer() {
    if (this._flag) {
      const container = document.getElementById('three-container');
      this._labelRenderer.setSize(
        container.clientWidth,
        container.clientHeight
      );
      this._css3dRenderer.setSize(
        container.clientWidth,
        container.clientHeight
      );
      if (container) {
        container.appendChild(this._labelRenderer.domElement);
        container.appendChild(this._css3dRenderer.domElement);
      }
    }
  }

  /**
   * Determines whether window resize on
   */
  private _onWindowResize = () => {
    this._camera.aspect = this.canvasRef.nativeElement.clientWidth/this.canvasRef.nativeElement.clientHeight
    this._camera.updateProjectionMatrix();
    this._renderer.setSize(this.canvasRef.nativeElement.clientWidth,this.canvasRef.nativeElement.clientHeight)
    this._labelRenderer.setSize(
     this.canvasRef.nativeElement.clientWidth,this.canvasRef.nativeElement.clientHeight
    );
    this._css3dRenderer.setSize(
      this.canvasRef.nativeElement.clientWidth,this.canvasRef.nativeElement.clientHeight
    );
}

}